import React, {Component, PropTypes} from 'react';
import {autobind} from 'core-decorators';
import classNames from 'classnames';

export default class Field extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        label: PropTypes.string,
        helpText: PropTypes.string,
        disabled: PropTypes.bool,
        icon: PropTypes.string,
    };

    static defaultProps = {
        label: undefined,
        disabled: false,
        icon: undefined,
    };

    state = {
        showHelp: false,
    };

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.label !== this.props.label
            || nextProps.helpText !== this.props.helpText
            || nextProps.children !== this.props.children
            || nextProps.disabled !== this.props.disabled
            || nextProps.icon !== this.props.icon
            || nextState.showHelp !== this.state.showHelp;
    }

    @autobind
    handleShowHelp() {
        this.setState({showHelp: true});
    }

    @autobind
    handleHideHelp() {
        this.setState({showHelp: false});
    }

    render() {
        const {label, helpText, children, disabled, icon} = this.props;
        return (
            <label className={classNames('cielo24-vwrap-form-field', {'cielo24-vwrap-disabled': disabled})}>
                {label && (
                    <div
                        className='cielo24-vwrap-label'
                        onMouseEnter={this.handleShowHelp}
                        onMouseLeave={this.handleHideHelp}
                    >
                        {icon && <i className={`cielo24-vwrap-icon cielo24-vwrap-icon-${icon}`} aria-hidden={true} />}
                        <span>{label}</span>
                        {helpText && (
                            <i className='cielo24-vwrap-icon cielo24-vwrap-icon-info cielo24-vwrap-icon-help-icon' />
                        )}
                        {helpText && this.state.showHelp && <div className='cielo24-vwrap-help-text'>{helpText}</div>}
                    </div>
                )}
                {children}
            </label>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/forms/field.js